import React, { useState } from 'react';
import styled from 'styled-components';
import { Plus, Trash2 } from 'lucide-react';
import { v4 as uuidv4 } from 'uuid';
import { PrimaryButton, SecondaryButton, DefaultButton } from '../Common/BaseButton';
import { getInitials } from '../../utils/utils';

const FormGroup = styled.div`
  margin-bottom: 1rem;
  width: 100%;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  
  &:focus {
    border-color: var(--primary-green);
    outline: none;
  }
`;

const SaveCancelButtons = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
`;

const Contact = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  border: 1px solid #e9ecef;
`;

const ContactIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--primary-green);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  margin-right: 1rem;
  flex-shrink: 0;
`;

const ContactInfo = styled.div`
  flex: 1;
`;

const ContactName = styled.div`
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

const ContactDetail = styled.div`
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 0.1rem;
`;

const ContactDeleteButton = styled.button`
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: #f8d7da;
  }
`;

const EventContacts = ({ 
  contacts, 
  onContactsChange, 
//   sendPreEventEmail, 
//   onSendPreEventEmailChange 
}) => {
  const [showContactForm, setShowContactForm] = useState(false);
  const [newContact, setNewContact] = useState({
    id: uuidv4(),
    name: '',
    role: '',
    phone: '',
    email: ''
  });

  // Email validation function
//   const isValidEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

  // Check if any contacts have valid emails
//   const hasValidEmailContacts = contacts.some(contact => 
//     contact.email && isValidEmail(contact.email)
//   );

  const handleAddContact = () => {
    setShowContactForm(true);
  };

  const handleSaveContact = () => {
    if (!newContact.name.trim()) return;

    const updatedContacts = [...contacts, { ...newContact }];
    onContactsChange(updatedContacts);
    
    setNewContact({
      id: uuidv4(),
      name: '',
      role: '',
      phone: '',
      email: ''
    });
    setShowContactForm(false);
  };

  const handleDeleteContact = (contactId) => {
    const updatedContacts = contacts.filter(contact => contact.id !== contactId);
    onContactsChange(updatedContacts);
  };

  const handleCancelContact = () => {
    setNewContact({
      id: uuidv4(),
      name: '',
      role: '',
      phone: '',
      email: ''
    });
    setShowContactForm(false);
  };

  return (
    <FormGroup>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
        <Label>Event Contacts</Label>
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            id="sendPreEventEmail"
            // checked={sendPreEventEmail}
            // onChange={(e) => onSendPreEventEmailChange(e.target.checked)}
            // disabled={!hasValidEmailContacts}
            disabled={true}
            style={{ cursor: hasValidEmailContacts ? 'pointer' : 'not-allowed' }}
          />
          <label 
            htmlFor="sendPreEventEmail" 
            style={{ 
              fontSize: '0.9rem', 
              color: hasValidEmailContacts ? '#333' : '#999',
              cursor: hasValidEmailContacts ? 'pointer' : 'not-allowed',
              userSelect: 'none'
            }}
          >
            Contact(s) will receive a pre-event email
          </label>
        </div> */}
      </div>
      
      {/* {sendPreEventEmail && !hasValidEmailContacts && (
        <div style={{ 
          fontSize: '0.85rem', 
          color: '#e74c3c', 
          marginBottom: '0.5rem',
          fontStyle: 'italic'
        }}>
          Add a contact with a valid email address to enable pre-event emails
        </div>
      )} */}
      
      <SecondaryButton 
        type="button"
        onClick={handleAddContact}
        style={{marginBottom: '0.5rem'}}
      >
        <Plus size={16} />
        Add
      </SecondaryButton>
    
      {showContactForm ? (
        <div style={{ marginBottom: '1rem' }}>
          <Input
            type="text"
            placeholder="Contact name"
            value={newContact.name}
            onChange={(e) => setNewContact({ ...newContact, name: e.target.value })}
            style={{ marginBottom: '0.5rem' }}
          />
          <Input
            type="text"
            placeholder="Role (e.g. Event Manager)"
            value={newContact.role}
            onChange={(e) => setNewContact({ ...newContact, role: e.target.value })}
            style={{ marginBottom: '0.5rem' }}
          />
          <Input
            type="tel"
            placeholder="Phone number"
            value={newContact.phone}
            onChange={(e) => setNewContact({ ...newContact, phone: e.target.value })}
            style={{ marginBottom: '0.5rem' }}
          />
          <Input
            type="email"
            placeholder="Email address"
            value={newContact.email}
            onChange={(e) => setNewContact({ ...newContact, email: e.target.value })}
            style={{ marginBottom: '0.5rem' }}
          />
          <SaveCancelButtons>
            <DefaultButton 
              type="button"
              onClick={handleCancelContact}
            >
              Cancel
            </DefaultButton>
            <PrimaryButton 
              type="button"
              onClick={handleSaveContact}
            >
              Add
            </PrimaryButton>
          </SaveCancelButtons>
        </div>
      ) : contacts.length === 0 ? (
        <div style={{ color: '#6c757d', fontSize: '0.9rem', textAlign: 'center', padding: '1rem 0' }}>
          No contacts added yet.
        </div>
      ) : (
        <div>
          {contacts.map((contact) => (
            <Contact key={contact.id}>
              <ContactIcon>
                {getInitials(contact.name)}
              </ContactIcon>
              <ContactInfo>
                <ContactName>{contact.name}</ContactName>
                {contact.role && <ContactDetail>{contact.role}</ContactDetail>}
                {contact.phone && (
                  <ContactDetail>
                    <a href={`tel:${contact.phone}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                      {contact.phone}
                    </a>
                  </ContactDetail>
                )}
                {contact.email && (
                  <ContactDetail>
                    <a href={`mailto:${contact.email}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                      {contact.email}
                    </a>
                  </ContactDetail>
                )}
              </ContactInfo>
              <ContactDeleteButton onClick={() => handleDeleteContact(contact.id)}>
                <Trash2 size={16} />
              </ContactDeleteButton>
            </Contact>
          ))}
        </div>
      )}
    </FormGroup>
  );
};

export default EventContacts;